import { Field, useFormikContext } from 'formik'

import TextBox from 'components/TextBox'
import TextBoxReset from 'components/TextBoxReset'

import { randomNumbersGenerator } from 'utils/randomNumbersGenerator'

const Info = ({ showValidationErrors, disabled }) => {
  const { values, errors, setFieldValue } = useFormikContext()

  return (
    <section className="item-settings__section">
      <h3 className="header-title">Info</h3>
      <div className="text-field">
        <Field
          component={TextBox}
          label="Name"
          name="name"
          showValidationErrors={showValidationErrors}
          value={values?.name}
          error={errors?.name}
          disabled={disabled}
        />
      </div>
      <div className="text-field">
        <Field
          component={TextBox}
          label="Email Address"
          name="email"
          showValidationErrors={showValidationErrors}
          value={values?.email}
          error={errors?.email}
          disabled={disabled}
        />
      </div>
      <div className="text-field">
        <Field
          component={TextBox}
          label="Phone Number"
          name="phone"
          value={values?.phone}
          error={errors?.phone}
          disabled={disabled}
        />
      </div>
      <div className="text-field">
        <Field
          component={TextBox}
          label="External ID"
          name="employeeId"
          value={values?.employeeId}
          error={errors?.employeeId}
          disabled={disabled}
        />
      </div>
      <div className="text-field">
        <Field
          component={TextBoxReset}
          label="PIN Code"
          name="pinNumber"
          onClick={() =>
            setFieldValue(
              'pinNumber',
              String(randomNumbersGenerator(5))
            )
          }
          onChange={(event) =>
            setFieldValue('pinNumber', event.target.value)
          }
          value={values?.pinNumber}
          error={errors?.pinNumber}
          showValidationErrors={showValidationErrors}
          disabled={disabled}
        />
        <p className="description margin-top-xxs margin-bottom-none color-disabled">
          Quick Service (QS) supports 5-6 digit PINs. Full Service
          (FS) supports 5 digit PINs.
        </p>
      </div>
    </section>
  )
}

export default Info
